/* Palmr Hero Banner — slide rotation + dots/arrows.
   Loaded once with defer; initializes every instance on the page.
   Extracted from the section's inline <script> (one copy per instance). */
(function () {
  function initHero(sectionEl) {
    if (!sectionEl || sectionEl.dataset.palmrHeroInit) return;
    sectionEl.dataset.palmrHeroInit = 'true';

    var slides = sectionEl.querySelectorAll('.palmr-hero__slide');
    var dots   = sectionEl.querySelectorAll('.palmr-hero__dot');
    if (slides.length <= 1) return;

    var current   = 0;
    var autoplay  = sectionEl.dataset.autoplay === 'true';
    var speed     = parseInt(sectionEl.dataset.speed, 10) || 6000;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
    }

    function startTimer() {
      if (!autoplay) return;
      sectionEl.__palmrHeroTimer = setInterval(function () { goTo(current + 1); }, speed);
    }

    function resetTimer() {
      clearInterval(sectionEl.__palmrHeroTimer);
      startTimer();
    }

    var prevBtn = sectionEl.querySelector('.palmr-hero__arrow--prev');
    var nextBtn = sectionEl.querySelector('.palmr-hero__arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetTimer(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.slide, 10));
        resetTimer();
      });
    });

    startTimer();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[id^="palmr-hero-"]').forEach(initHero);
  }

  initAll();

  /* Theme editor: re-init reloaded sections, stop timers on unload. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[id^="palmr-hero-"]').forEach(function (el) {
      clearInterval(el.__palmrHeroTimer);
    });
  });
})();
